<template>
  <div class="Content">
    <div class="SearchBar">
      <DefaultSearchInput
        v-model="searchText"
        placeholder="Поиск по имени или фамилии"
      />
    </div>
    <div
      v-if="isLoading"
      class="loader-container"
    >
      <div class="spinning-loader">
          <div class="spinner-ring ring-1"></div>
          <div class="spinner-ring ring-2"></div>
          <div class="spinner-ring ring-3"></div>
          <div class="center-dot"></div>
      </div>
      <div class="loading-text">Загрузка...</div>
    </div>
    <table v-else class="Request-Table">
      <thead>
        <tr>
          <th>Имя Фамилия</th>
          <th>Номер телефона</th>
          <th>Дата создания</th>
          <th>Комментарий</th>
        </tr>
      </thead>
      <tbody>
        <tr 
          v-for="requests in filteredRequests" 
          :key="requests.id"
          class="Request" 
        >
          <td style="width: 349px">{{ requests.surname_name }}</td>
          <td style="min-width: 160px">{{ requests.phone }}</td>
          <td style="min-width: 120px">{{ normalDate(requests.createdAt) }}</td>
          <td>{{ requests.additional }}</td>
        </tr>
      </tbody>
    </table>
    <Pagination
      class="LastElement"
      :key="`Pagination-${paginationKey}`"
      :dataCounter="filteredRequestsCount"
      :max_items="maxItems"
      :max_pages_indexes="5"
      :startPage="currentPage"
      @update:page="handlePageChange"
    />
  </div>
</template>

<script>
import DefaultSearchInput from "@/components/OctaUI/Inputs/DefaultSearchInput.vue";
import Pagination from "@/components/OctaUI/Pagination.vue";

import { GetNoCourse } from "@/api/request.js";

export default {
  components: {
    DefaultSearchInput,
    Pagination
  },
  data() {
    return {
      requestsNoCourse: [],

      searchText: "",

      isLoading: true,
      filteredRequestsCount: 0,
      paginationKey: Date.now(),
      currentPage: 1,
      maxItems: 8,
    }
  },
  mounted() {
    this.getNoCourse();
  },
  computed: {
    filteredRequests() {
      let requests = [...this.requestsNoCourse];

      // Фильтрация
      requests = requests.filter(request => {
        // Поиск по названию
        if(!request.surname_name.toLowerCase().includes(this.searchText.toLowerCase())) {
          return false;
        }
        
        return true;
      });

      // Перенаправление на 1 страницу, если количество курсов меньше текущей страницы
      if((this.currentPage - 1) * this.maxItems >= requests.length) {
        this.paginationKey++;
        this.handlePageChange(1);
      }

      // Записываем фактическое количество курсов после фильтрации до slice
      this.filteredRequestsCount = requests.length;

      // Возвращаем курсы для данной страницы(currentPage)
      return requests.slice(
        this.maxItems * (this.currentPage - 1), 
        this.maxItems * (this.currentPage - 1) + this.maxItems
      );
    },
  },
  methods: {
    async getNoCourse() {
      try {
        let countRequest = 0;
        let dataLastRequest = [];

        // Загружаем список компаний пакетами по maxItems
        while(countRequest === 0 || dataLastRequest.length > 0) {
          dataLastRequest = (await GetNoCourse(this.maxItems, countRequest * this.maxItems)).data;

          this.requestsNoCourse.push(...dataLastRequest);

          // Если произошла загрузка первого пакета - убираем лоадер
          if(countRequest === 0) {
            this.isLoading = false;
          }

          countRequest++;
        }
      } catch (e) {
        console.log(e);
      }
    },
    normalDate(date) {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, '0');
      const month = String(newDate.getMonth() + 1).padStart(2, '0');
      const year = newDate.getFullYear();
      
      return `${day}.${month}.${year}`;
    },
    handlePageChange(page) {
      this.currentPage = page; 
    },
  }
};
</script>

<style scoped>
p, h1, h2, h3, h4, h5, h6 {
  margin: 0;
  padding: 0;
}
.Content .SearchBar {
  position: relative;
  display: flex;
  
  flex-direction: row;

  margin-top: 40px;
  gap: 25px;
}
.Content h3 {
  font-family: 'Involve';
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  color: #232323;
}
.Content p {
  font-family: 'Involve';
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #666666;
}
.Content a {
  font-family: 'Involve';
  font-weight: 500;
  line-height: 150%;
  color: #666666;
}
.Request-Table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;

  background: #F3F3F3; 
  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1), 0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 16px;
  margin-top: 24px;
}
.Request-Table th {
  font-family: 'Involve';
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  height: 56px;
  color: #1A1A1A;
  padding-left: 24px;
  padding-right: 24px;
  text-align: left;

  word-break: break-word;
}
.Request-Table td {
  font-family: 'Involve';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  align-items: center;
  color: #1A1A1A;
  padding-left: 24px;
  padding-right: 24px;
  text-align: left;
  border-bottom: 1px solid #ddd;

  word-break: break-word;
}
.Request {
  width: 100%;
  height: 48px;
  transition: all 0.3s ease;
  background: #FFFFFF;
}
.Request-Info {
  position: relative;
  display: flex;

  flex-direction: column;
  gap: 20px;
}
.LastElement {
  margin-top: 40px;
}
.loader-container {
    text-align: center;
    margin-top: 80px;
}
.spinning-loader {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
}
.spinner-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation: spin 2s linear infinite;
}
.ring-1 {
    border: 3px solid transparent;
    border-top: 3px solid #F9D773E5;
    border-right: 3px solid #F9D773E5;
}
.ring-2 {
    border: 3px solid transparent;
    border-top: 3px solid #F9D77333;
    border-right: 3px solid #F9D77333;
    width: 70%;
    height: 70%;
    top: 15%;
    left: 15%;
    animation-duration: 1.5s;
    animation-direction: reverse;
}
.ring-3 {
    border: 3px solid transparent;
    border-top: 3px solid #F9D7731A;
    border-right: 3px solid #F9D7731A;
    width: 50%;
    height: 50%;
    top: 25%;
    left: 25%;
    animation-duration: 1s;
}
.center-dot {
    position: absolute;
    width: 12px;
    height: 12px;
    background: #F9D773E5;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: pulse-center 2s infinite ease-in-out;
}
.loading-text {
    color: #000000;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 2px;
    animation: pulse 2s infinite;
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@keyframes pulse {
    0%, 100% {
        opacity: 0.7;
        transform: scale(1);
    }
    50% {
        opacity: 1;
        transform: scale(1.05);
    }
}
@keyframes pulse-center {
    0%, 100% {
        transform: translate(-50%, -50%) scale(1);
        box-shadow: 0 0 10px #F9D773E5;
    }
    50% {
        transform: translate(-50%, -50%) scale(1.2);
        box-shadow: 0 0 20px #F9D773E5, 0 0 30px #F9D77333;
    }
}
</style>